export default {"src":"/_next/static/media/googleplay.60ef3a49.svg","height":50,"width":187,"blurWidth":0,"blurHeight":0};